import type { IEndpoint } from '../../types';

import { casinoConfigParser } from './parsers';
import type { CasinoConfigResponse, CasinoConfigType } from './types';

export const casinoConfigEndpoint: IEndpoint<CasinoConfigType, undefined> = {
  url: '/api/config/casino',
  parser: (rawResponse): CasinoConfigType => casinoConfigParser(rawResponse as CasinoConfigResponse),
  format: 'json',
};
